import { MAT_NATIVE_DATE_FORMATS, MatDateFormats } from '@angular/material/core';

export enum AUTH_METHOD {
  EMAIL = 'email',
  USERNAME = 'username',
  TELEGRAM_BOT = 'telegram_bot',
  PHONE = 'phone',
}

export enum PROGRESS_STATUSES {
  NOT_INITIALIZED = 'NOT_INITIALIZED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export interface PermissionModel {
  id: UUID;
  name: PermissionEnum;
}

export enum PermissionEnum {
  UNKNOWN = 'unknown',

  SUPER_USER = 'super_user',
  ADMIN = 'administrator',

  // Orders
  CAN_READ_ORDERS = 'can_read_orders',
  CAN_READ_ORDERS_BY_ID = 'can_read_orders_by_id',
  CAN_READ_EQUIPMENT_OF_ORDER = 'can_read_equipment_of_order',
  CAN_READ_RECEIPT_OF_ORDER = 'can_read_receipt_of_order',
  CAN_WRITE_RECEIPT_OF_ORDER = 'can_write_receipt_of_order',
  CAN_CHANGE_ORDER_STATUS = 'can_change_order_status',
  CAN_WRITE_ORDERS = 'can_write_orders',

  // talons
  CAN_READ_TALONS = 'can_read_talons',
  CAN_WRITE_TALONS = 'can_write_talons',
  CAN_READ_TALONS_BY_ID = 'can_read_talons_by_id',
  CAN_READ_RECEIPT_OF_TALON = 'can_read_receipt_of_talon',
  CAN_WRITE_RECEIPT_OF_TALON = 'can_write_receipt_of_talon',
  CAN_MANAGE_TALON_TEMPLATES = 'can_manage_talon_templates',

  // Stands
  CAN_READ_STANDS = 'can_read_stands',
  CAN_WRITE_STANDS = 'can_write_stands',
  CAN_READ_STANDS_BY_ID = 'can_read_stands_by_id',
  CAN_CHANGE_STAND_STATUS = 'can_change_stand_status',
  CAN_READ_RECEIPT_OF_STAND = 'can_read_receipt_of_stand',
  CAN_WRITE_RECEIPT_OF_STAND = 'can_write_receipt_of_stand',


  // Contracts
  CAN_WRITE_CONTRACT = 'can_write_contract',
  CAN_READ_CONTRACTS = 'can_read_contracts',
  CAN_READ_CONTRACT_BY_ID = 'can_read_contract_by_id',

  CAN_READ_DEBT_BY_ID = 'can_read_debt_by_id',
  CAN_READ_DEBTS = 'can_read_debt',
  CAN_WRITE_DEBTS = 'can_write_debt',

  CAN_SAVE_FORCE = 'can_save_force',

  CAN_READ_FINANCE_REGISTER = 'can_read_finance_register',
  CAN_CREATE_SCORES = 'can_create_scores',
  CAN_REMOVE_SCORES = 'can_remove_scores',
  CAN_UPDATE_SCORES = 'can_update_scores',

  CAN_CREATE_CATEGORY = 'can_create_category',
  CAN_REMOVE_CATEGORY = 'can_remove_category',
  CAN_UPDATE_CATEGORY = 'can_update_category',

  CAN_READ_COMPLETED_WORK = 'can_read_completed_work',
  CAN_READ_COMPLETED_WORK_AS_ADMIN = 'can_read_completed_work_as_admin',

  CAN_READ_INVOICES = 'can_read_invoices',
  CAN_READ_INVOICE_BY_ID = 'can_read_invoice_by_id',
  CAN_WRITE_RECEIPT_OF_INVOICE = 'can_write_receipt_of_invoice',
  CAN_WRITE_INVOICES = 'can_write_invoices',
  CAN_REDA_RECEIPT_OF_INVOICE = 'can_reda_receipt_of_invoice',

  //Clients
  CAN_READ_CLIENTS = 'can_read_clients',

  // SIP / Asterisk
  ACCESS_TO_SIP = 'access_to_sip',
  // Telegram-чат з клієнтами (у mobile — лише з цим дозволом)
  ACCESS_TO_TELEGRAM_CHAT = 'access_to_telegram_chat',
  ACCESS_TO_CONTACT_IDENTIFICATION = 'access_to_contact_identification',

}


/**
 * Describes all possible error formats.
 * Application can't be sure what fields are present, so such error object should be defined or unified.
 */
export interface UnknownError<T = ErrorFromBackend> extends Error {
  /** If error occurred on backend => it returned as TS error wrap with field `error`. */
  error?: T;
}


/** Default backend error. May contain `detail`, `detail_code` or other field related data. */
export interface ErrorFromBackend {
  message: string;
  error?: string;
  statusCode?: number;
}

export type UUID = string;


export interface PaginatorModel<T> {
  data: T[];
  meta: {
    itemsPerPage: number;
    totalItems: number;
    currentPage: number;
    totalPages: number;
    sortBy: [string, 'ASC' | 'DESC'][];
  },
  links: {
    first: string;
    previous: string;
    current: string;
    next: string;
    last: string;
  }
}


export interface PaginateQuery<T> {
  page?: number;
  limit?: number;
  sortBy?: [string, string][];
  searchBy?: string[];
  search?: string;
  filter?: T;
  select?: string[];
  path?: string;
}

export const MY_DATE_FORMATS: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    dateInput: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    } as Intl.DateTimeFormatOptions,
    monthYearLabel: {
      year: 'numeric',
      month: 'long'
    } as Intl.DateTimeFormatOptions
  }
};


export enum MODE_COMPONENT {
  VIEW = 'VIEW',
  MANAGE = 'MANAGE',
  CREATE = 'CREATE',
}


export const ACCESS_TOKEN_KEY = 'access_token';
